export default __webpack_public_path__ + "static/media/Steel-Storage-Racks.fe842b6f.jpg";